import type { TokenDefinition, } from "@bracket/chainography/types";
export const ankrETH: TokenDefinition<"ANKRETH", "ankrETH"> = {
	name: "ankrETH",
	symbol: "ANKRETH",
	label: "ankrETH",
	chainId: 1,
	address: "0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
	priceFeedAddress: "0xNEED",
	decimals: 18,
	logoURI:
		"https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978",
	fees: [],
	swapto: false,
	stakable: true,
	parity: false,
	escrow: false,
	stablecoin: false,
} as const;
export const ANKRETH = ankrETH;

export const brktETH: TokenDefinition<"BRKTETH", "brktETH"> = {
	name: "bracket ETH",
	symbol: "BRKTETH",
	label: "brktETH",
	chainId: 1,
	address: "0x6C8550167BbD06D4610a6A443eCbEd84Bd1AccD6",
	logoURI: "/public/brktEth.png",
	decimals: 18,
	parity: false,
	platform: true,
	denominable: true,
	stablecoin: false,
} as const;
export const BRKTETH = brktETH;

export const cbETH: TokenDefinition<"CBETH", "cbETH"> = {
	name: "Coinbase Assets",
	symbol: "CBETH" as const,
	label: "cbETH",
	chainId: 1,
	address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
	decimals: 18,
	logoURI: "https://res.coinpaper.com/coinpaper/cbeth_kfal8a.png",
	fees: [100],
	stakable: true,
	parity: false,
	swapto: true,
	escrow: true,
	bridge: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};
export const CBETH = cbETH;

// ETH is at the bottom.

export const eETH: TokenDefinition<"EETH", "eETH"> = {
	name: "ether.fi ETH",
	symbol: "EETH" as const,
	label: "eETH",
	chainId: 1,
	address: "0x35fA164735182de50811E8e2E824cFb9B6118ac2",
	priceFeedAddress: "0xNEED",
	decimals: 18,
	logoURI: "https://coin-images.coingecko.com/coins/images/33049/large/ether.fi_eETH.png?1700473063",
	fees: [0],
	stakable: true,
	parity: true,
	swapto: false,
	inactive: false, // BracketOracle::getRate is breaking
	escrow: false, // escrow uses its wrapped verwsion WETH
	platform: true,
	platform_supply: false,
	stablecoin: false,
};

export const EETH = eETH;

export const ezETH: TokenDefinition<"EZETH", "ezETH"> = {
	name: "ezETH",
	symbol: "EZETH" as const,
	label: "ezETH",
	chainId: 1,
	address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
	priceFeedAddress: "0x636A000262F6aA9e1F094ABF0aD8f645C44f641C",
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/ezETHv2_32.png",
	fees: [100, 10000, 500],
	stakable: true,
	parity: false,
	swapto: true,
	inactive: false,
	disabled: true,
	// escrow: true,
	stablecoin: false,
};
export const EZETH = ezETH;

export const osETH: TokenDefinition<"OSETH", "osETH"> = {
	name: "os eth",
	symbol: "OSETH" as const,
	label: "osETH",
	chainId: 1,
	address: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
	decimals: 18,
	logoURI: "/assets/crypto/oseth.png",
	fees: [100, 10000, 500],
	stakable: true,
	parity: false,
	swapto: false,
	// inactive: true, // BracketOracle::getRate is breaking
	escrow: false, //TODO: SHOULD BE TRUE! - getRate is reverting atm
	stablecoin: false,
};
export const OSETH = osETH;

export const rETH: TokenDefinition<"RETH", "rETH"> = {
	name: "rocket pool ether",
	symbol: "RETH" as const,
	label: "rETH",
	chainId: 1,
	address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
	priceFeedAddress: "0x536218f9E9Eb48863970252233c8F271f554C2d0",
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/rocketpooleth_32.png?v=2",
	fees: [500, 3000],
	stakable: true,
	parity: false,
	swapto: true,
	escrow: true,
	bridge: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};
export const RETH = rETH;

export const rsETH: TokenDefinition<"RSETH", "rsETH"> = {
	name: "rsETH",
	symbol: "RSETH" as const,
	label: "rsETH",
	chainId: 1,
	address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
	priceFeedAddress: "0x03c68933f7a3F76875C0bc670a58e69294cDFD01",
	decimals: 18,
	logoURI:
		"https://img.cryptorank.io/coins/60x60.kelp_dao_restaked_eth1716362924229.png",
	fees: [10000, 3000, 500],
	stakable: true,
	parity: false,
	swapto: false,
	// inactive: true, // BracketOracle::getRate is breaking
	escrow: true,
	bridge: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};
export const RSETH = rsETH;

export const sfrxETH: TokenDefinition<"SFRXETH", "sfrxETH"> = {
	name: "sfrxETH",
	symbol: "SFRXETH" as const,
	label: "sfrxETH",
	chainId: 1,
	address: "0xac3E018457B222d93114458476f3E3416Abbe38F",
	decimals: 18,
	logoURI:
		"https://1160856619-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2F-MJQZW1mSg2O5N7HXHo0-1972196547%2Fuploads%2FydkGnK4T3NEsQcCSq0F0%2FsfrxETH%20icon.svg?alt=media&token=8f5341b1-e88b-4644-919a-a9b5b250df22",
	fees: [],
	stakable: true,
	parity: false,
	swapto: false,
	escrow: false,
	stablecoin: false,
};
export const SFRXETH = sfrxETH;

export const stETH: TokenDefinition<"STETH", "stETH"> = {
	name: "stETH",
	symbol: "STETH" as const,
	label: "stETH",
	chainId: 1,
	address: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
	priceFeedAddress: "0x86392dC19c0b719886221c78AB11eb8Cf5c52812",
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/wsteth3_32.png",
	fees: [100],
	stakable: true,
	parity: true,
	swapto: false,
	inactive: false, // BracketOracle::getRate is breaking
	escrow: false, // escrow uses its wrapped verwsion WSTETH
	bridge: true,
	platform: true,
	platform_supply: false,
	stablecoin: false,
};
export const STETH = stETH;

export const STONE: TokenDefinition<"STONE", "STONE"> = {
	name: "stone",
	symbol: "STONE" as const,
	label: "STONE",
	chainId: 1,
	address: "0x7122985656e38BDC0302Db86685bb972b145bD3C",
	decimals: 18,
	logoURI: "/public/stone.png",
	fees: [],
	stakable: true,
	parity: false,
	swapto: false,
	// disabled: true,
	escrow: true,
	bridge: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};

export const weETH = {
	name: "wrapped eETH",
	symbol: "WEETH" as const,
	label: "weETH",
	chainId: 1,
	address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
	priceFeedAddress: "0x5c9C449BbC9a6075A2c061dF312a35fd1E05fF22",
	decimals: 18,
	logoURI: "https://arbiscan.io/token/images/etherfiweeth_32.png",
	fees: [100, 3000],
	stakable: true,
	parity: false,
	swapto: true,
	escrow: true,
	bridge: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};
export const WEETH = weETH;

export const wETH: TokenDefinition<"WETH", "wETH"> = {
	name: "wrapped ether",
	symbol: "WETH" as const,
	label: "wETH",
	chainId: 1,
	address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
	priceFeedAddress: "0xCc72039A141c6e34a779eF93AEF5eB4C82A893c7",
	decimals: 18,
	logoURI:
		"https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png",
	fees: [],
	swapto: false,
	swapable: true,
	parity: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
	wrapped: true,
};
export const WETH = wETH;

export const wstETH: TokenDefinition<"WSTETH", "wstETH"> = {
	name: "wrapped liquid staked ether",
	symbol: "WSTETH",
	label: "wstETH",
	chainId: 1,
	address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
	priceFeedAddress: "0xNEED",
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/wsteth3_32.png",
	fees: [100],
	swapto: true,
	stakable: true,
	parity: false,
	escrow: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
};
export const WSTETH = wstETH;

export const fBTC: TokenDefinition<"FBTC", "fBTC"> = {
	name: "fractional BTC",
	address: "0xC96dE26018A54D51c097160568752c4E3BD6C364",
	symbol: "FBTC" as const,
	label: "fBTC",
	chainId: 1,
	decimals: 18,
	logoURI: "https://etherscan.io/token/images/fbtc_32.png",
	fees: [],
	parity: false,
	swapto: false,
	escrow: false,
	platform: false,
	platform_supply: false,
	stablecoin: false,
};
export const FBTC = fBTC;

export const USDC: TokenDefinition<"USDC", "USDC"> = {
	name: "USD Coin",
	symbol: "USDC" as const,
	label: "USDC",
	chainId: 1,
	address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
	logoURI: "https://etherscan.io/token/images/usdc_ofc_32.svg",
	decimals: 6,
	parity: false,
	swapto: false,
	escrow: false,
	platform: false,
	platform_supply: false,
	denominable: true,
	stablecoin: true,
};

export const WBTC: TokenDefinition<"WBTC", "wBTC"> = {
	name: "wrapped BTC",
	symbol: "WBTC" as const,
	label: "wBTC",
	chainId: 1,
	address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
	logoURI: "https://etherscan.io/token/images/wrappedbtc_ofc_32.svg",
	decimals: 8,
	parity: false,
	swapto: false,
	escrow: false,
	platform: false,
	platform_supply: false,
	denominable: true,
	stablecoin: false,
};

export const ETH: TokenDefinition<"ETH", "ETH"> = {
	name: "ethereum",
	symbol: "ETH" as const,
	label: "ETH",
	chainId: 1,
	address: WETH.address,
	decimals: 18,
	logoURI: "https://cdn.iconscout.com/icon/free/png-256/free-ethereum-1824287-1545899.png",
	fees: [],
	swapto: false,
	swapable: true,
	parity: true,
	platform: true,
	platform_supply: true,
	stablecoin: false,
	wrapped: false,
};
